<script setup lang="ts">
    const { t } = useI18n();
    const scrollToElement = () => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    };

    let onScroll: (() => void) | null = null;

    onMounted(() => {
        const btnScrollToTop = document.querySelector('#btt-button');

        onScroll = () => {
            const scrollPosition = window.scrollY;
            const windowHeight = document.documentElement.scrollHeight - window.innerHeight;
            if (scrollPosition > windowHeight / 2) {
                btnScrollToTop?.classList.add('--visible');
            } else {
                btnScrollToTop?.classList.remove('--visible');
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
    });

    onBeforeUnmount(() => {
        if (onScroll) window.removeEventListener('scroll', onScroll);
    });
</script>

<template>
    <button
        id="btt-button"
        class="btt-button"
        :aria-label="t('general.backToTop')"
        @click="scrollToElement()"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            viewBox="0 0 24 24"
            class="lucide lucide-chevron-up"
        >
            <path d="m18 15-6-6-6 6" />
        </svg>
    </button>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/basics/back-to-top.scss';
</style>
